// extracted by mini-css-extract-plugin
export default {"mediaItem__image":"MediaImage_mediaItem__image__-a1mk"};